import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  logout: () => api.post('/auth/logout'),
  checkAuth: () => api.get('/admin/check-auth'),
  register: (userData) => api.post('/auth/register', userData),
};

// Applications API
export const applicationsAPI = {
  checkEmail: (email) => api.post('/applications/check-email', { email }),
  submitApplication: (formData) => api.post('/applications', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  getApplications: (filters = {}) => api.get('/applications', { params: filters }),
  getApplicationById: (id) => api.get(`/applications/${id}`),
  updateApplication: (id, data) => api.put(`/applications/${id}`, data),
  deleteApplication: (id) => api.delete(`/applications/${id}`),
  exportToExcel: () => api.get('/applications/export/excel', { responseType: 'blob' }),
};

// Settings API
export const settingsAPI = {
  getDeadline: () => api.get('/settings/deadline'),
  setDeadline: (deadline) => api.post('/admin/settings/deadline', { deadline }),
};

// Careers API
export const careersAPI = {
  getPositions: () => api.get('/careers/positions'),
  apply: (formData) => api.post('/careers/apply', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  getAdminPositions: () => api.get('/admin/careers/positions'),
  createPosition: (data) => api.post('/admin/careers/positions', data),
  updatePosition: (id, data) => api.put(`/admin/careers/positions/${id}`, data),
  togglePosition: (id) => api.post(`/admin/careers/positions/${id}/toggle`),
  deletePosition: (id) => api.delete(`/admin/careers/positions/${id}`),
  getDashboard: () => api.get('/admin/careers/dashboard'),
  reviewApplication: (id) => api.post(`/admin/careers/applications/${id}/review`),
  shortlistApplication: (id) => api.post(`/admin/careers/applications/${id}/shortlist`),
  hireApplication: (id) => api.post(`/admin/careers/applications/${id}/hire`),
  rejectApplication: (id, reason) => api.post(`/admin/careers/applications/${id}/reject`, { reason }),
  exportExcel: (filters = {}) => api.get('/admin/careers/applications/export/excel', { params: filters, responseType: 'blob' }),
};

// Email API
export const emailAPI = {
  sendNotification: (applicationId, email) => api.post('/email/send-notification', { applicationId, email }),
};

export default api;
